import React from 'react';
import { AppRouter } from './AppRouter';
import { ThemeProvider } from './contexts/ThemeContext';
export function App() {
  return <ThemeProvider data-id="element-0">
      <AppRouter data-id="element-1" />
    </ThemeProvider>;
}